<template>
	<div class="banner-container">
		<!-- 图片滚动区：居中, 16:9, 外层div不受Swiper JS控制 -->
		<div class="banner-img-box">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div
						class="swiper-slide"
						v-for="item in bannerList"
						:key="item.id"
						:class="{ 'is-link': isValidLink(item.linkUrl) }"
						@click="handleBannerClick(item)"
					>
						<img :src="item.picUrl" />
					</div>
				</div>
				<!-- 分页器始终渲染，不受公告栏v-if影响 -->
				<div class="swiper-pagination"></div>
			</div>
		</div>

		<!-- 公告栏：绝对定位覆盖图片底部 -->
		<div class="announcement-bar" v-if="memberCount > 0 || welcomeUser">
			<div class="announcement-left">
				<!-- <span class="announcement-icon">📢</span> -->
				<span class="member-badge" v-if="memberCount > 0">
					<span class="member-label">会员</span>
					<span class="member-value">{{ memberCount }}</span>
				</span>
				<span class="welcome-badge" v-if="welcomeUser">
					<!-- <span class="welcome-icon">🎉</span> -->
					<span class="welcome-scroll">
						<span class="welcome-text">{{ welcomeUser }}</span>
					</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'

export default {
	name: 'banner',
	data() {
		return {
			bannerList: [],
			memberCount: 0,
			welcomeUser: ''
		}
	},
	created() {
		this.getStatistics()
	},
	async mounted() {
		await this.getDataList()
		await this.$nextTick()
		this.initSwiper()
	},
	methods: {
		isValidLink(url) {
			return url && /^https?:\/\//i.test(url)
		},
		handleBannerClick(item) {
			if (this.isValidLink(item.linkUrl)) {
				window.open(item.linkUrl, '_blank')
			}
		},
		async getDataList() {
			try {
				const res = await post('v1/index/bannerData', qs.stringify({}))
				if (res.data.code == 200) {
					this.bannerList = res.data.list
				} else {
					this.$message.error(res.data.msg || '获取轮播图失败')
				}
			} catch (e) {
				console.log('获取轮播图数据失败', e)
			}
		},
		async getStatistics() {
			try {
				const res = await post('v1/index/countPostNum', qs.stringify({}))
				if (res.data.code == 200) {
					const data = res.data.entity || {}
					this.memberCount = data.countAllUserNum || 0
					this.welcomeUser = data.newUserName ? '欢迎新会员' + data.newUserName + ' 加入' : ''
				}
			} catch (e) {
				console.log('获取统计数据失败', e)
			}
		},
		initSwiper() {
		new Swiper(".swiper-container", {
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: 5000,
			autoplayDisableOnInteraction: false,
			effect: "slide",
			pagination: '.swiper-pagination',
			paginationClickable: true,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev'
		})
	}
	}
}
</script>

<style scoped lang="less">
/* ===== 1. 最外层容器：满宽白色背景 ===== */
.banner-container {
	position: relative;
	background: #fff;
}

/* ===== 2. 图片区：全屏宽度, 1920:560 比例 ===== */
.banner-img-box {
	position: relative;
	width: 100%;
	aspect-ratio: 1920 / 560;
	overflow: hidden;

	.swiper-container {
		width: 100%;
		height: 100%;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.swiper-slide.is-link {
		cursor: pointer;
	}
}

/* ===== 3. 左右箭头 ===== */
/deep/ .swiper-button-next {
	background-image: url("~@/assets/arrow_right.png");
}
/deep/ .swiper-button-prev {
	background-image: url("~@/assets/arrow_left.png");
}
/deep/ .swiper-button-next,
/deep/ .swiper-button-prev {
	width: 56px;
	height: 56px;
	margin-top: -28px;
	background-size: 56px 56px;
}

/* ===== 4. 公告栏：与下方内容区左侧对齐, 轻量毛玻璃 ===== */
.announcement-bar {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 44px;
	padding: 0 calc((100% - 1180px) / 2 + 24px);
	background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
	box-sizing: border-box;
	z-index: 5;
	display: flex;
	align-items: center;

	.announcement-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.announcement-icon {
		font-size: 14px;
	}

	/* 会员标签 */
	.member-badge {
		display: flex;
		align-items: center;
		gap: 4px;
		background: linear-gradient(135deg, #667eea, #764ba2);
		border-radius: 10px;
		padding: 2px 10px;
	}
	.member-label {
		font-size: 11px;
		color: rgba(255, 255, 255, 0.85);
	}
	.member-value {
		font-size: 13px;
		font-weight: 700;
		color: #fff;
	}

	/* 新成员标签（跑马灯） */
	.welcome-badge {
		position: relative;
		display: flex;
		align-items: center;
		background: linear-gradient(135deg, #fff7e6, #fff1cc);
		border: 1px solid #ffd666;
		border-radius: 10px;
		padding: 2px 10px 2px 24px;
		max-width: 180px;
	}
	.welcome-icon {
		position: absolute;
		left: 6px;
		font-size: 11px;
		z-index: 1;
	}
	.welcome-scroll {
		overflow: hidden;
		flex: 1;
	}
	.welcome-text {
		display: inline-block;
		font-size: 12px;
		color: #d48806;
		white-space: nowrap;
		animation: welcome-marquee 8s linear infinite;
	}
}

/* ===== 5. 分页器：公告栏上方居中，最外层 ===== */
/deep/ .swiper-pagination {
	position: absolute;
	bottom: 14px;
	left: 0;
	right: 0;
	text-align: center;
	z-index: 20;
}
/deep/ .swiper-pagination-bullet {
	background: rgba(255, 255, 255, 0.6);
	opacity: 1;
}
/deep/ .swiper-pagination-bullet-active {
	background: #DD0515;
}

/* ===== 6. 跑马灯动画 ===== */
@keyframes welcome-marquee {
	0%   { transform: translateX(180px); }
	100% { transform: translateX(-100%); }
}
</style>
